import { AuthService } from '../../../services/auth.service';
import { IScheduleJob } from '../../schedule.service/schedule.job.model';

export class IdleJob implements IScheduleJob {
    id = 'IdleJob';
    udpateInterval = 1200;
    callback = () => {
        if (this.authService.isAuthorized) {
            this.authService.refreshSession();
        }
    }

    constructor(
        private authService: AuthService
    ) { }
}


// WEBPACK FOOTER //
// ./src/app/common/elements/component.idle/idleJob.ts